// NOTE: We are using this directive as a component
import { Directive } from '@angular/core';


/**
 * The floating label for a {@link TsFormFieldComponent}
 */
// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: 'ts-label' })
export class TsLabelDirective {}
